import { media } from '@domain-group/fe-brary';
import { css } from '@emotion/core';
export var modalBody = /*#__PURE__*/css("display:flex;flex-direction:column;padding:24px 16px;gap:8px;", media('>=tablet'), "{padding:24px;width:525px;}");